import React, { memo } from "react";
import { PieChart as PieRechart, Pie, Cell, Label } from "recharts";

import * as SC from "./PieChart.styled";

import DataVizStore from "../../../../../Stores/DataVizStore";
import { withRefluxStore } from "../../../../../Stores";
import useDataVizPercentage from "../../hooks/useDataVizPercentage";

const skeletonData = [{ name: "skeleton", value: 1 }];

const PieChart = memo(({ data, selectedChannel, isAnimationActive = true, cardKey = "" }) => {
  const { calculatePercentage } = useDataVizPercentage();

  const isChannelValueEmpty = data.every((metric) => metric.value == 0 || metric.value == null);

  const isSelectedChannelValueEmpty = data.some(
    (metric) =>
      metric.name == selectedChannel[cardKey] && (metric.value == 0 || metric.value == null)
  );

  const showPercentage =
    selectedChannel[cardKey] && !isSelectedChannelValueEmpty && !isChannelValueEmpty;

  // Filter out metrics with value 0
  const filteredData = data.filter((metric) => metric.value > 0);

  return (
    <SC.PieChartWrapper>
      <PieRechart width={60} height={60}>
        <Pie
          data={isChannelValueEmpty || isSelectedChannelValueEmpty ? skeletonData : filteredData}
          cx={"50%"}
          cy={"50%"}
          minAngle={20}
          startAngle={90}
          endAngle={-360}
          innerRadius={15}
          outerRadius={25}
          fill="#8884d8"
          key={Math.random()}
          dataKey="value"
          isAnimationActive={isAnimationActive}
        >
          {isChannelValueEmpty || isSelectedChannelValueEmpty ? (
            <Cell key={`cell-empty`} fill={"#ABB4F4"} />
          ) : (
            filteredData.map((metric, index) => (
              <Cell
                key={`cell-${index}`}
                fill={SC.selectColorPalette(index, metric, selectedChannel[cardKey])}
                className="animated-cell"
              />
            ))
          )}
          {showPercentage && (
            <Label
              value={calculatePercentage(data, selectedChannel[cardKey])}
              offset={0}
              position="center"
              style={SC.PercentageLabel}
            />
          )}
        </Pie>
      </PieRechart>
      {showPercentage && <div>%</div>}
    </SC.PieChartWrapper>
  );
});

PieChart.displayName = "PieChart";
export default withRefluxStore(PieChart, [DataVizStore], ["selectedChannel"]);
